import { FC } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

interface RtpTrendEntry {
  date: string;
  painNRS: number;
  confidenceScore: number;
  fearScore: number;
}

interface RtpConfidenceFearChartProps {
  data: RtpTrendEntry[];
}

export const RtpConfidenceFearChart: FC<RtpConfidenceFearChartProps> = ({ data }) => {
  if (data.length === 0) {
    return <div style={{ padding: 16, textAlign: 'center', color: '#718096', fontSize: 13 }}>Nessun dato disponibile.</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={220}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" tick={{ fontSize: 10 }} />
        <YAxis domain={[0, 10]} tick={{ fontSize: 10 }} />
        <Tooltip />
        <Legend />
        <Line
          type="monotone"
          dataKey="confidenceScore"
          stroke="#38A169"
          name="Fiducia"
          strokeWidth={2}
          dot={{ r: 3, fill: '#38A169' }}
        />
        <Line
          type="monotone"
          dataKey="fearScore"
          stroke="#DD6B20"
          name="Paura"
          strokeWidth={2}
          dot={{ r: 3, fill: '#DD6B20' }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default RtpConfidenceFearChart;
